export const onCreateConversation = /* GraphQL */ `
  subscription OnCreateConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onCreateConversation(filter: $filter) {
      id
      status
      userId
      agentId
      campaignId
      participantPhoneNumber
      participantFirstName
      participantLastName
      participantLinkedInProfile
      createdAt
      updatedAt
      messages {
        items {
          id
          body
        }
        nextToken
      }
      createdAt
      updatedAt
      activeChannel
    }
  }
`;

export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onCreateMessage(filter: $filter) {
      id
      body
      status
      conversation {
        id
        status
        userId
        agentId
        campaignId
        twilioParticipantId
        twilioConversationId
        participantPhoneNumber
        participantFirstName
        participantLastName
        participantLinkedInProfile
        messagesCount
        createdAt
        updatedAt
      }
      conversationId
      agentId
      userId
      campaignId
      sender
      createdAt
      isInitial
      updatedAt
      emailSubjectLine
      media {
        contentType
        twilioMediaSid
        fileName
      }
      templateId
      template {
        type
      }
    }
  }
`;

export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onUpdateMessage(filter: $filter) {
      id
      body
      sender
      userId
      status
      conversationId
      agentId
      twilioMessageId
      twilioErrorCode
      campaignId
      createdAt
      isInitial
      updatedAt
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage($filter: ModelSubscriptionMessageFilterInput) {
    onDeleteMessage(filter: $filter) {
      id
      body
      sender
      userId
      status
      conversationId
      agentId
      twilioMessageId
      twilioErrorCode
      campaignId
      createdAt
      isInitial
      updatedAt
    }
  }
`;

export const onUpdateConversation = /* GraphQL */ `
  subscription OnUpdateConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onUpdateConversation(filter: $filter) {
      id
      status
      userId
      agentId
      campaignId
      twilioParticipantId
      twilioConversationId
      participantPhoneNumber
      participantFirstName
      participantLastName
      participantLinkedInProfile
      participantEmailAddress
      messagesCount
      createdAt
      updatedAt
      isRead
      isHumanTakeover
      pastOngoingConversationId
      isWebChatJoined
      twilioRedirectConversationId
      twilioRedirectParticipantId
      screeningQuestionsOutcome {
        screeningQuestion
        questionOutcome
        responseSummary
      }
      openQuestionOutcomes {
        question
        responseSummary
        score
        openQuestionRequirementOutcomes {
          content
          isMet
          evidence
        }
      }
      errorCode
      needsReview
      activeChannel
      meetingBookingStatus
    }
  }
`;

export const onCreateUnansweredQuestion = /* GraphQL */ `
  subscription OnCreateUnansweredQuestion(
    $filter: ModelSubscriptionUnansweredQuestionFilterInput
  ) {
    onCreateUnansweredQuestion(filter: $filter) {
      id
      summary
      isAnswered
      conversationId
      campaignId
      associatedMessageId
      associatedMessage {
        id
        body
        sender
        userId
        status
        conversationId
        agentId
        twilioMessageId
        twilioErrorCode
        campaignId
        createdAt
        deliveredAt
        readAt
        isInitial
        updatedAt
        messageUnansweredQuestionId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
